<template>
    <div class="choice-page">
        <!-- 顶部装饰背景 -->
        <div class="choice-header-bg">
            <div class="header-circle c1"></div>
            <div class="header-circle c2"></div>
            <div class="header-circle c3"></div>
        </div>

        <!-- 选择卡片 -->
        <div class="choice-card">
            <div class="card-header">
                <div class="brand-icon">
                    <span class="icon-heart">♥</span>
                </div>
                <span class="card-title">欢迎回来</span>
                <span class="card-desc">您希望以哪种方式开始？</span>
            </div>
            <div class="card-body">
                <!-- 直接聊天 -->
                <div class="choice-btn primary" @click="goToChat">
                    <span class="btn-main">直接聊天</span>
                    <span class="btn-sub">与小酒窝自由对话</span>
                </div>
                <!-- 心理评估 -->
                <div class="choice-btn secondary" @click="goToAssessment">
                    <span class="btn-main">心理评估</span>
                    <span class="btn-sub">完成问卷获得专业分析</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { setStorage } from '@/utils/storage.js';

export default {
    methods: {
        /** 直接聊天：进入聊天页普通聊天模式（type=chat 决定只恢复普通会话） */
        goToChat() {
            this.$router.replace('/chat?type=chat');
        },
        /** 心理评估：进入聊天页评估模式（type=assessment 只恢复评估会话），needAssessment 标记触发自动开始新评估 */
        goToAssessment() {
            // 评估标记：聊天首页 created 检测到后自动启动评估模式
            setStorage('needAssessment', true);
            this.$router.replace('/chat?type=assessment');
        },
    },
};
</script>

<style lang="scss" scoped>
.choice-page {
    min-height: 100vh;
    // 与门户页统一的携程蓝渐变背景
    background: linear-gradient(180deg, #d8ebff 0%, #e9f4ff 24%, #f5f7fa 60%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

// 顶部装饰圆
.choice-header-bg {
    position: absolute;
    top: -60rpx;
    right: -40rpx;
}
.header-circle {
    position: absolute;
    border-radius: 50%;
    opacity: 0.15;
    &.c1 {
        width: 240rpx;
        height: 240rpx;
        background: #0a6cf5;
        top: 0;
        right: 0;
    }
    &.c2 {
        width: 160rpx;
        height: 160rpx;
        background: #5db1ff;
        top: 120rpx;
        right: -60rpx;
    }
    &.c3 {
        width: 100rpx;
        height: 100rpx;
        background: #0a6cf5;
        top: 40rpx;
        right: 100rpx;
    }
}

/* 选择卡片 */
.choice-card {
    width: 90%;
    max-width: 680rpx;
    background: #ffffff;
    border-radius: 32rpx;
    box-shadow: 0 24rpx 64rpx rgba(10, 108, 245, 0.12), 0 12rpx 32rpx rgba(0, 0, 0, 0.06);
    overflow: hidden;
    position: relative;
    z-index: 10;
    // 卡片顶部品牌色条
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 10rpx;
        background: linear-gradient(90deg, #5db1ff 0%, #0a6cf5 50%, #0857c9 100%);
    }
}

.card-header {
    padding: 56rpx 48rpx 44rpx;
    text-align: center;
}

.brand-icon {
    width: 88rpx;
    height: 88rpx;
    margin: 0 auto 24rpx;
    background: linear-gradient(135deg, #5db1ff 0%, #0a6cf5 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8rpx 24rpx rgba(10, 108, 245, 0.3);
}
.icon-heart {
    font-size: 40rpx;
    color: #ffffff;
}

.card-title {
    font-size: 44rpx;
    font-weight: 700;
    color: #123c7a;
    letter-spacing: 4rpx;
    display: block;
}

.card-desc {
    font-size: 28rpx;
    color: #8a94a6;
    margin-top: 16rpx;
    font-weight: 400;
    letter-spacing: 1rpx;
    display: block;
}

.card-body {
    padding: 20rpx 48rpx 56rpx;
}

/* 选择按钮（间距用 margin，兼容旧浏览器禁用 gap） */
.choice-btn {
    height: 140rpx;
    border-radius: 24rpx;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 24rpx;
    transition: all 0.3s ease;
    cursor: pointer;

    &:last-child {
        margin-bottom: 0;
    }

    &:active {
        transform: scale(0.97);
    }

    .btn-main {
        font-size: 34rpx;
        font-weight: 600;
        margin-bottom: 8rpx;
    }

    .btn-sub {
        font-size: 24rpx;
        font-weight: 400;
        opacity: 0.8;
    }

    // 主按钮：携程蓝渐变（与登录按钮统一）
    &.primary {
        background: linear-gradient(135deg, #5db1ff 0%, #0a6cf5 100%);
        box-shadow: 0 8rpx 24rpx rgba(10, 108, 245, 0.3);

        .btn-main,
        .btn-sub {
            color: #fff;
        }
    }

    // 次按钮：浅灰底
    &.secondary {
        background: #f5f6fa;

        .btn-main {
            color: #45536b;
        }

        .btn-sub {
            color: #8a94a6;
        }
    }
}
</style>
